export default "__VITE_ASSET__Dfy5vC7W__"